<suite-rfb-collapse title="Composição" [collapsed]="this.collapsed" (collapsedChange)="this.onCollapsedChange($event)">
  <suite-rfb-alert-messages-with-datetime [onlyFor]="this.scopeId"></suite-rfb-alert-messages-with-datetime>
  <ng-container *ngIf="this.composicoes?.length > 0; else loadingOrError">
    <div class="table-responsive">
      <span class="informacao-tabela">
        <span><b>Contribuinte</b>:</span>
        <span>{{ this.pagamento.niContribuinte | formatCpfCnpjPipe }} : {{ this.pagamento.nomeContribuinte }}</span>
      </span>
      <table suiteRfbTable>
        <caption>Composição</caption>
        <thead>
          <tr>
            <th class="text-center min-width">
              <suite-rfb-toggle title="Expandir/Contrair Todos Detalhes" (expanded)="expandeTodosDetalhes($event)">
              </suite-rfb-toggle>
            </th>
            <th class="text-center min-width">Sequencial</th>
            <th class="text-center min-width">Código Principal</th>
            <th class="text-center min-width">Valor Principal</th>
            <th class="text-center min-width">Código Multa</th>
            <th class="text-center min-width">Valor Multa</th>
            <th class="text-center min-width">Código Juros</th>
            <th class="text-center min-width">Valor Juros</th>
            <th class="text-center min-width">Código Encargo</th>
            <th class="text-center min-width">Valor Encargo</th>
            <th class="text-center min-width">Valor Total</th>
            <th class="text-center min-width">Situação</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let composicao of this.composicoes | currentPage: this.currentPage">
            <tr class="vertical-align-middle">
              <td class="text-center">
                <suite-rfb-toggle #detalhes></suite-rfb-toggle>
              </td>
              <td class="text-center">
                {{ composicao.sequencialDesmembramento | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.codigoPrincipal | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.valorPrincipal | formatCurrency | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.codigoMulta | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.valorMulta | formatCurrency | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.codigoJuros | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.valorJuros | formatCurrency | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.codigoEncargo | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.valorEncargo | formatCurrency | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.valorTotal | formatCurrency | vazio }}
              </td>
              <td class="text-center min-width text-nowrap">
                {{ composicao.situacao | vazio }}
              </td>
            </tr>
            <ng-container *ngIf="detalhes.show">
              <!-- A tag <tr> abaixo é necessária para sincronizar a cor de fundo da tela de detalhes -->
              <!-- com as cores alternadas das linhas da tabela -->
              <tr></tr>
              <tr>
                <td colspan="12" class="background-inherit">
                  <div class="contorno">
                    <section class="section-custom">
                      <h2 class="section-title">Detalhes da Composição</h2>

                      <!-- Fileira 1 -->
                      <div class="row fileira-gradeada">
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            CNPJ/CPF do Débito
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.cnpjCpfDebito | formatCpfCnpjPipe | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            CNPJ-Prestador
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.cnpjPrestador | formatCnpjPipe | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            CPF-Segurado
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.cpfSegurado | formatCpfPipe | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Data Vencimento
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.dataVencimento | date:"dd/MM/yyyy" | vazio }}
                          </p>
                        </div>
                      </div>

                      <!-- Fileira 2 -->
                      <div class="row fileira-gradeada">
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            NIT
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.numeroIdentificacaoTrabalhador | padStart:11:"0" | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            CNO
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.numeroCadastroNacionalObras | formatCnoPipe | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            CIB
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.numeroIdentificacaoTrabalhador | cib | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Período de Apuração
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.periodoApuracao | date:"MM/yyyy" | vazio }}
                          </p>
                        </div>
                      </div>

                      <!-- Fileira 3 -->
                      <div class="row fileira-gradeada">
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Processo
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.processo | padStart:17:"0" | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Processo/Informação Complementar
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.procInfoComplementar | padStart:17:"0" | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Inscrição Dívida Ativa
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.numeroInscricaoDAU | padStart:13:"0" | vazio}}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Referência
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.referencia | padStart:17:"0" | vazio }}
                          </p>
                        </div>
                      </div>

                      <!-- Fileira 4 -->
                      <div class="row fileira-gradeada">
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Receita
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.fracoes[0].receita.receitaNome | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Extensão da Receita
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.fracoes[0].receita.extensaoReceitaTexto | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Sistema de Interesse
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.sistemaInteresse.descricao | vazio }}
                          </p>
                        </div>
                        <div class="col-md-3">
                          <label class="label-formulario control-label">
                            Ente Federado
                          </label>
                          <p class="form-control-static dado-formulario">
                            {{ composicao.destinacao?.descricao | vazio }}
                          </p>
                        </div>
                      </div>
                    </section>
                  </div>
                </td>
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
        <tfoot>
          <tr class="tabela-rodape-acoes">
            <td colspan="12">
              <via-pagination [itemAmount]="this.composicoes.length" [(page)]="this.currentPage"></via-pagination>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </ng-container>
</suite-rfb-collapse>

<ng-template #loadingOrError>
  <div *ngIf="initError; else loading">
  </div>
  <ng-template #loading>
    <loading-animation *ngIf="!stopLoading"></loading-animation>
  </ng-template>
</ng-template>